import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, Card, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

export default function HistoricTabs() {
  const [activeDisplayOption, setActiveDisplayOption] = useState(
    'total_active_wallets'
  );
  const [chartDaysAgo, setChartDaysAgo] = useState('30');

  const displayOptions = useMemo(
    () => [
      { key: 'total_active_wallets', value: 'Active wallets' },
      { key: 'total_wallets_cumulative', value: 'Cumulative' },
      { key: 'total_new_wallets', value: 'New wallets' }
    ],
    []
  );

  const [data, error] = useApi<SimpleChartData[]>({
    url: '/overall/historic/',
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      <HistoricGraphs
        data={data}
        type={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    </Card>
  );
}
